/* Jonathan Snook - MIT License - https://github.com/snookca/prepareTransition */
(function(a){a.fn.prepareTransition=function(){return this.each(function(){var b=a(this);b.one("TransitionEnd webkitTransitionEnd transitionend oTransitionEnd",function(){b.removeClass("is-transitioning")});var c=["transition-duration","-moz-transition-duration","-webkit-transition-duration","-o-transition-duration"];var d=0;a.each(c,function(a,c){d=parseFloat(b.css(c))||d});if(d!=0){b.addClass("is-transitioning");b[0].offsetWidth}})}})(jQuery);

/* replaceUrlParam - http://stackoverflow.com/questions/7171099/how-to-replace-url-parameter-with-javascript-jquery */
function replaceUrlParam(e,r,a){var n=new RegExp("("+r+"=).*?(&|$)"),c=e;return c=e.search(n)>=0?e.replace(n,"$1"+a+"$2"):c+(c.indexOf("?")>0?"&":"?")+r+"="+a};

var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}

/*============================================================================
  Money Format
  - Shopify.format money is defined in option_selection.js.
    If that file is not included, it is redefined here.
==============================================================================*/

if ((typeof Shopify) === 'undefined') { Shopify = {}; }
if (!Shopify.formatMoney) {
  Shopify.formatMoney = function(cents, format) {
    var value = '',
        placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
        formatString = (format || this.money_format);

    if (typeof cents == 'string') {
      cents = cents.replace('.','');
    }

    function defaultOption(opt, def) {
      return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal   = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number/100.0).toFixed(precision);

      var parts   = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          cents   = parts[1] ? (decimal + parts[1]) : '';

      return dollars + cents;
    }

    switch(formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  };
}

// Timber functions
window.timber = window.timber || {};

timber.cacheSelectors = function () {
  timber.cache = {
    // General
    $html                    : $('html'),
    $body                    : $(document.body),

    // Navigation
    $navigation              : $('#AccessibleNav'),
    $mobileSubNavToggle      : $('.mobile-nav__toggle'),

    // Collection Pages
    $changeView              : $('.change-view'),

    // Product Page
    $productImage            : $('#ProductPhotoImg'),
    $thumbImages             : $('#ProductThumbs').find('a.product-single__thumbnail'),

    // Customer Pages
    $recoverPasswordLink     : $('#RecoverPassword'),
    $hideRecoverPasswordLink : $('#HideRecoverPasswordLink'),
    $recoverPasswordForm     : $('#RecoverPasswordForm'),
    $customerLoginForm       : $('#CustomerLoginForm'),
    $passwordResetSuccess    : $('#ResetSuccess')
  };
};

timber.init = function () {
  FastClick.attach(document.body);
  timber.cacheSelectors();
  timber.accessibleNav();
  timber.drawersInit();
  timber.mobileNavToggle();
  timber.productImageSwitch();
  timber.responsiveVideos();
  timber.collectionViews();
  timber.loginForms();
};

timber.accessibleNav = function () {
  var $nav = timber.cache.$navigation,
      $allLinks = $nav.find('a'),
      $topLevel = $nav.children('li').find('a'),
      $parents = $nav.find('.site-nav--has-dropdown'),
      $subMenuLinks = $nav.find('.site-nav__dropdown').find('a'),
      activeClass = 'nav-hover',
      focusClass = 'nav-focus';

  // Mouseenter
  $parents.on('mouseenter touchstart', function(evt) {
    var $el = $(this);

    if (!$el.hasClass(activeClass)) {
      evt.preventDefault();
    }

    showDropdown($el);
  });

  // Mouseout
  $parents.on('mouseleave', function() {
    hideDropdown($(this));
  });

  $subMenuLinks.on('touchstart', function(evt) {
    // Prevent touchstart on body from firing instead of link
    evt.stopImmediatePropagation();
  });

  $allLinks.focus(function() {
    handleFocus($(this));
  });

  $allLinks.blur(function() {
    removeFocus($topLevel);
  });

  // accessibleNav private methods
  function handleFocus ($el) {
    var $subMenu = $el.next('ul'),
        hasSubMenu = $subMenu.hasClass('sub-nav') ? true : false,
        isSubItem = $('.site-nav__dropdown').has($el).length,
        $newFocus = null;

    // Add focus class for top level items, or keep menu shown
    if (!isSubItem) {
      removeFocus($topLevel);
      addFocus($el);
    } else {
      $newFocus = $el.closest('.site-nav--has-dropdown').find('a');
      addFocus($newFocus);
    }
  }

  function showDropdown ($el) {
    $el.addClass(activeClass);

    setTimeout(function() {
      timber.cache.$body.on('touchstart', function() {
        hideDropdown($el);
      });
    }, 250);
  }

  function hideDropdown ($el) {
    $el.removeClass(activeClass);
    timber.cache.$body.off('touchstart');
  }

  function addFocus ($el) {
    $el.addClass(focusClass);
  }

  function removeFocus ($el) {
    $el.removeClass(focusClass);
  }
};

timber.drawersInit = function () {
  timber.LeftDrawer = new timber.Drawers('NavDrawer', 'left');
  
};

timber.mobileNavToggle = function () {
  timber.cache.$mobileSubNavToggle.on('click', function() {
    $(this).parent().toggleClass('mobile-nav--expanded');
  });
};

timber.getHash = function () {
  return window.location.hash;
};

timber.productPage = function (options) {
  var moneyFormat = options.money_format,
      variant = options.variant,
      selector = options.selector;

  // Selectors
  var $productImage = $('#ProductPhotoImg'),
      $addToCart = $('#AddToCart'),
      $productPrice = $('#ProductPrice'),
      $comparePrice = $('#ComparePrice'),
      $quantityElements = $('.quantity-selector, label + .js-qty'),
      $addToCartText = $('#AddToCartText');

  if (variant) {

    // Update variant image, if one is set
    if (variant.featured_image) {
      var newImg = variant.featured_image,
          el = $productImage[0];
      Shopify.Image.switchImage(newImg, el, timber.switchImage);
    }

    // Select a valid variant if available
    if (variant.available) {
      // Available, enable the submit button, change text, show quantity elements
      $addToCart.removeClass('disabled').prop('disabled', false);
      $addToCartText.html("Purchase");
      $quantityElements.show();
    } else {
      // Sold out, disable the submit button, change text, hide quantity elements
      $addToCart.addClass('disabled').prop('disabled', true);
      $addToCartText.html("Sold Out");
      $quantityElements.hide();
    }

    // Regardless of stock, update the product price
    $productPrice.html( Shopify.formatMoney(variant.price, moneyFormat) );

    // Also update and show the product's compare price if necessary
    if (variant.compare_at_price > variant.price) {
      $comparePrice
        .html("" + ' ' + Shopify.formatMoney(variant.compare_at_price, moneyFormat))
        .show();
    } else {
      $comparePrice.hide();
    }

  } else {
    // The variant doesn't exist, disable submit button.
    // This may be an error or notice that a specific variant is not available.
    // To only show available variants, implement linked product options:
    //   - http://docs.shopify.com/manual/configuration/store-customization/advanced-navigation/linked-product-options
    $addToCart.addClass('disabled').prop('disabled', true);
    $addToCartText.html("Sold Out");
    $quantityElements.hide();
  }
};

timber.productImageSwitch = function () {
  if (timber.cache.$thumbImages.length) {
    // Switch the main image with one of the thumbnails
    // Note: this does not change the variant selected, just the image
    timber.cache.$thumbImages.on('click', function(evt) {
      evt.preventDefault();
      var newImage = $(this).attr('href');
      timber.switchImage(newImage, null, timber.cache.$productImage);
    });
  }
};

timber.switchImage = function (src, imgObject, el) {
  // Make sure element is a jquery object
  var $el = $(el);
  $el.attr('src', src);
};

timber.responsiveVideos = function () {
  var $iframeVideo = $('iframe[src*="youtube.com/embed"], iframe[src*="player.vimeo"]');
  var $iframeReset = $iframeVideo.add('iframe#admin_bar_iframe');

  $iframeVideo.each(function () {
    // Add wrapper to make video responsive
    $(this).wrap('<div class="video-wrapper"></div>');
  });

  $iframeReset.each(function () {
    // Re-set the src attribute on each iframe after page load
    // for Chrome's "incorrect iFrame content on 'back'" bug.
    // https://code.google.com/p/chromium/issues/detail?id=395791
    // Need to specifically target video and admin bar
    this.src = this.src;
  });
};

timber.collectionViews = function () {
  if (timber.cache.$changeView.length) {
    timber.cache.$changeView.on('click', function() {
      var view = $(this).data('view'),
          url = document.URL,
          hasParams = url.indexOf('?') > -1;

      if (hasParams) {
        window.location = replaceUrlParam(url, 'view', view);
      } else {
        window.location = url + '?view=' + view;
      }
    });
  }
};

timber.loginForms = function() {
  function showRecoverPasswordForm() {
    timber.cache.$recoverPasswordForm.show();
    timber.cache.$customerLoginForm.hide();
  }

  function hideRecoverPasswordForm() {
    timber.cache.$recoverPasswordForm.hide();
    timber.cache.$customerLoginForm.show();
  }

  timber.cache.$recoverPasswordLink.on('click', function(evt) {
    evt.preventDefault();
    showRecoverPasswordForm();
  });

  timber.cache.$hideRecoverPasswordLink.on('click', function(evt) {
    evt.preventDefault();
    hideRecoverPasswordForm();
  });

  // Allow deep linking to recover password form
  if (timber.getHash() == '#recover') {
    showRecoverPasswordForm();
  }
};

timber.resetPasswordSuccess = function() {
  timber.cache.$passwordResetSuccess.show();
};

/*============================================================================
  Drawer modules
  - Docs http://shopify.github.io/Timber/#drawers
==============================================================================*/
timber.Drawers = (function () {
  var Drawer = function (id, position, options) {
    var defaults = {
      close: '.js-drawer-close',
      open: '.js-drawer-open-' + position,
      openClass: 'js-drawer-open',
      dirOpenClass: 'js-drawer-open-' + position
    };

    this.$nodes = {
      parent: $('body, html'),
      page: $('#PageContainer'),
      moved: $('.is-moved-by-drawer')
    };

    this.config = $.extend(defaults, options);
    this.position = position;

    this.$drawer = $('#' + id);

    if (!this.$drawer.length) {
      return false;
    }

    this.drawerIsOpen = false;
    this.init();
  };

  Drawer.prototype.init = function () {
    $(this.config.open).on('click', $.proxy(this.open, this));
    this.$drawer.find(this.config.close).on('click', $.proxy(this.close, this));
  };

  Drawer.prototype.open = function (evt) {
    // Keep track if drawer was opened from a click, or called by another function
    var externalCall = false;

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the drawer opens, the click event bubbles up to $nodes.page
    // which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    }

    // Notify the drawer is going to open
    timber.cache.$body.trigger('beforeDrawerOpen.timber', this);

    // Add is-transitioning class to moved elements on open so drawer can have
    // transition for close animation
    this.$nodes.moved.addClass('is-transitioning');
    this.$drawer.prepareTransition();

    this.$nodes.parent.addClass(this.config.openClass + ' ' + this.config.dirOpenClass);
    this.drawerIsOpen = true;

    // Set focus on drawer
    this.trapFocus(this.$drawer, 'drawer_focus');

    // Run function when draw opens if set
    if (this.config.onDrawerOpen && typeof(this.config.onDrawerOpen) == 'function') {
      if (!externalCall) {
        this.config.onDrawerOpen();
      }
    }

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    // Lock scrolling on mobile
    this.$nodes.page.on('touchmove.drawer', function () {
      return false;
    });

    this.$nodes.page.on('click.drawer', $.proxy(function () {
      this.close();
      return false;
    }, this));

    // Notify the drawer has opened
    timber.cache.$body.trigger('afterDrawerOpen.timber', this);
  };

  Drawer.prototype.close = function () {
    if (!this.drawerIsOpen) { // don't close a closed drawer
      return;
    }

    // Notify the drawer is going to close
    timber.cache.$body.trigger('beforeDrawerClose.timber', this);

    // deselect any focused form elements
    $(document.activeElement).trigger('blur');

    // Ensure closing transition is applied to moved elements, like the nav
    this.$nodes.moved.prepareTransition({ disableExisting: true });
    this.$drawer.prepareTransition({ disableExisting: true });

    this.$nodes.parent.removeClass(this.config.dirOpenClass + ' ' + this.config.openClass);

    this.drawerIsOpen = false;

    // Remove focus on drawer
    this.removeTrapFocus(this.$drawer, 'drawer_focus');

    this.$nodes.page.off('.drawer');

    // Notify the drawer is closed now
    timber.cache.$body.trigger('afterDrawerClose.timber', this);
  };

  Drawer.prototype.trapFocus = function ($container, eventNamespace) {
    var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';

    $container.attr('tabindex', '-1');

    $container.focus();

    $(document).on(eventName, function (evt) {
      if ($container[0] !== evt.target && !$container.has(evt.target).length) {
        $container.focus();
      }
    });
  };

  Drawer.prototype.removeTrapFocus = function ($container, eventNamespace) {
    var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';

    $container.removeAttr('tabindex');
    $(document).off(eventName);
  };

  return Drawer;
})();


// Initialize Timber's JS on docready
$(timber.init);



$(document).ready(function() {
  if( typeof(productOptions ) != "undefined" ){
    for(var i=0;i<productOptions.length;i++) {
      $('.single-option-selector:eq('+ i +')')
      .filter(function() {
        return $(this).find('option').length > 1
      })
      .prepend('<option value="">Pick a ' + productOptions[i][i] + '</option>')
      .val('')
      .trigger('change');
    }
  }
  function timeFormatting(timestamp, i) {
    let time;
    if (Math.floor(Math.round(timestamp) / 60) >= 60) {
      time = Math.floor(Math.round(timestamp) / 3600) + i +  ('0' + Math.floor(Math.round(Math.round(timestamp) % 3600) / 60)).slice(-2) + i + ('0' + Math.round(timestamp) % 60).slice(-2)
    } else if (Math.floor(Math.round(timestamp) / 60) >= 1) {
      time = Math.floor(Math.round(timestamp) / 60) + i + ('0' + Math.round(timestamp) % 60).slice(-2)
    } else {
      time = i == '.' ? '0' + i + Math.round(timestamp) % 60 : ('0' + Math.round(timestamp) % 60).slice(-2)
    }
    return time
  }
  $podcasts = $('.podcast')
  var audio = null
  var video = null, progressInterval, timestampInterval,percentElapsed;
  function startTicker(m) {
    progressInterval = setInterval(function() {
      percentElapsed = m.currentTime / m.duration * 100
      document.getElementById('time-elapsed').style.width = `${percentElapsed}%`
    }, 15)
    timestampInterval = setInterval(function(){
      document.getElementById('current-time').innerHTML = timeFormatting(m.currentTime, ':')
    }, 1000);
  }
  function startVideoTicker(m, duration) {
    progressInterval = setInterval(function() {
      m.getCurrentTime().then(function(seconds) {
        percentElapsed = seconds / duration * 100
        document.getElementById('time-elapsed').style.width = `${percentElapsed}%`
      })
    }, 50)
    timestampInterval = setInterval(function(){
      m.getCurrentTime().then(function(seconds) {
        document.getElementById('current-time').innerHTML = timeFormatting(seconds, ':')
      })
    }, 1000);
  }
  function stopTicker() {
    clearInterval(progressInterval)
    clearInterval(timestampInterval)
  }
  if ($podcasts.length > 0 ) {
    (function(){
      var progressGutter = 30, percentClickPosition;
      $('.progress').on('click', function(e) {
        // Progress bar width
        percentClickPosition = (e.clientX - progressGutter) / $(this).width()
        var m;
        if (audio) {
          m = audio
          m.currentTime = percentClickPosition * m.duration
          document.getElementById('current-time').innerHTML = timeFormatting(m.currentTime, ':')
        }
        else {
          video.getDuration().then(function(duration) {
            video.setCurrentTime(percentClickPosition * duration).then(function(seconds) {
              // seconds = the actual time that the player seeked to
            }).catch(function(error) {
              switch (error.name) {
                case 'RangeError':
                  // the time was less than 0 or greater than the video’s duration
                  break;

                default:
                  // some other error occurred
                  break;
              }
            });
          })

        }


      })

    })();
    var started = false
      function fadedVideos() {
      started = true
          function shuffle(array) {
              var currentIndex = array.length, temporaryValue, randomIndex;

              // While there remain elements to shuffle...
              while (0 !== currentIndex) {

                // Pick a remaining element...
                randomIndex = Math.floor(Math.random() * currentIndex);
                currentIndex -= 1;

                // And swap it with the current element.
                temporaryValue = array[currentIndex];
                array[currentIndex] = array[randomIndex];
                array[randomIndex] = temporaryValue;
              }

              return array;
            }
            function getRandomInt(max) {
              return Math.floor(Math.random() * Math.floor(max));
            }
            var randomContent = document.querySelectorAll('.random-content')
            setInterval(function() {
              if (document.querySelector('.open-content')) {
                document.querySelector('.open-content').classList.remove('open-content')      
              }
              var top = getRandomInt(75)
              var left = getRandomInt(75)
              var shuffledArray = [...randomContent]
              shuffle(shuffledArray)
              var beenPlayed = document.querySelectorAll('.beenPlayed')
              if (beenPlayed.length === shuffledArray.length) {
                for (var j = 0;j < beenPlayed.length;j++) {
                    beenPlayed[j].classList.remove('beenPlayed')
                }
              }
              for (var i = 0; i < shuffledArray.length;i++) {
                if (!shuffledArray[i].classList.contains('beenPlayed')) {
                  shuffledArray[i].classList.add('open-content')
                  shuffledArray[i].classList.add('beenPlayed')
                  shuffledArray[i].style.top = `${top}vh`
                  shuffledArray[i].style.left = `${left}vh`
                  if (shuffledArray[i].tagName !== 'IMG') {
                  	shuffledArray[i].play()

                  }
                  return
                }
              }
         }, 20000);
      }
      $podcasts.on('click', function() {
        $id = $(this).attr('id')
        if ($(this).hasClass('active-podcast')) {
          return
        } else {
          closeRoutine()
        }
        this.classList.add('active-podcast')
        if (document.querySelector('.open-content')) {
        	document.querySelector('.open-content').classList.remove('open-content')
        }
        $dataDiv = $('.podcast-content-container').find(`[data-id='${$id}']`)
        $('.active-podcast-content').removeClass('active-podcast-content')
        $dataDiv.addClass('active-podcast-content')
        $('.controls').addClass('playing')
        if (audio !== null) {
          audio.pause()
        }
        if (video !== null) {
          video.pause()
        }
        video = null
        audio = null
        if ($('.active-podcast-content').data('type') == 'audio') {
          audio = new Audio($dataDiv.data('src'))
          audio.play()
          audio.addEventListener('loadedmetadata', function() {
            startTicker(audio)
            document.getElementById('total-time').innerHTML = timeFormatting(audio.duration, ':')
            document.getElementById('current-time').innerHTML = timeFormatting(audio.currentTime, ':')
          })
          audio.addEventListener('ended',function() {
            closeRoutine()
          },false);
        } else {
          video = $dataDiv.find('iframe')[0]
          video = new Vimeo.Player(video)
          video.getDuration().then(function(duration) {
            // `duration` indicates the duration of the video in seconds
            document.getElementById('total-time').innerHTML = timeFormatting(duration, ':')
            startVideoTicker(video, duration)
          });
          video.getCurrentTime().then(function(current) {
            document.getElementById('current-time').innerHTML = timeFormatting(current, ':')
          })
          video.on('ended', function() {
            // ended = whether or not the video has ended
            console.log('ended')
            closeRoutine()
          })
                  $('.controls').removeClass('playing')

        }
        document.getElementById('track-title').innerHTML = $(this).html()
        $('.controls').addClass('open')
        $(this).addClass('active-podcast')
        if (!started && $('.active-podcast-content').data('type') == 'audio') {
          fadedVideos();
        }
      })
    document.body.onkeyup = function(e){
      if(e.keyCode == 32){
        //your code
        if ($('.controls').hasClass('playing')) {
          if (audio != null ) {
            audio.pause()
          } else if (video != null ){
            video.pause()
          }
          $('.playing').removeClass('playing')
        } else {
          if (audio != null ) {
            audio.play()
          } else if (video != null ){
            video.play()
          }
          $('.controls').addClass('playing')
        }
      }
    }
    document.getElementById('play').addEventListener('click', function() {
      if (audio != null ) {
        audio.play()
      } else if (video != null ){
        video.play()

      }
      $('.controls').addClass('playing')
    })
    document.getElementById('pause').addEventListener('click', function() {
      if (audio != null ) {
        audio.pause()
      } else if (video != null ){
        video.pause()
      }
      $('.playing').removeClass('playing')
    })
    function closeRoutine() {
      $('.active-podcast').removeClass('active-podcast')
      $('.active-podcast-content').removeClass('active-podcast-content')
      $('.controls').removeClass('open')
      clearInterval(fadedVideos)
      started = false
      if (audio != null ) {
        audio.pause()
        stopTicker()
      } else if (video != null ){
        video.pause()
        stopTicker()
      }

      video = null
      audio = null
    }
    document.getElementById('close').addEventListener('click', closeRoutine)
    $podcasts.on('mouseenter', function() {
      if ($('.active-podcast').length == 0)
         $(this).siblings().addClass('ap')
    })
    $podcasts.on('mouseleave', function() {
      $(this).siblings().removeClass('ap')
    })
  }



});